import {
  Activity,
  AlertCircle,
  Bell,
  FileText,
  LayoutGrid,
  Sparkles,
} from "lucide-react";

/** Icon glyph for a context chip, keyed by the chip's `icon` slug. */
export function ChipIcon({ icon }: { icon?: string }) {
  switch (icon) {
    case "alert":
      return <AlertCircle className="h-2 w-2 text-sky-500" />;
    case "cpu":
      return <LayoutGrid className="h-2 w-2 text-sky-500" />;
    case "activity":
      return <Activity className="h-2 w-2 text-sky-500" />;
    case "bell":
      return <Bell className="h-2 w-2 text-sky-500" />;
    case "file":
      return <FileText className="h-2 w-2 text-sky-500" />;
    default:
      return <Sparkles className="h-2 w-2 text-sky-500" />;
  }
}
